<template>
  <div class="topic-header">
    <div class="back" @click="onClickLeft">
      <img src="@/assets/img/back.png" alt="">
    </div>
    <div class="complete" v-if="!subtopicShow" @click="complete">完成评估</div>
    <template v-if="subtopicShow">
      <div class="title">{{ subtopicInfo.script }}</div>
      <div class="statistics">
        <div class="correct">+{{ statisticsInfo.correctNum }}</div>
        <div class="error">-{{ statisticsInfo.errorNum }}</div>
        <div class="num">
          <span class="current">{{ statisticsInfo.current }}</span>/{{ statisticsInfo.total }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "TopicHeader",
  props: {
    subtopicShow: {
      type: Boolean,
      default: false
    },
    subtopicInfo: {
      type: Object,
      default: () => ({})
    },
    statisticsInfo: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    onClickLeft() {
      if (this.subtopicShow) {
        this.$emit("update:subtopicShow", false)
      } else {
        this.$router.go(-1);
      }
    },
    complete() {
      this.$emit('complete');
    }
  }
}
</script>

<style lang="less" scoped>
.topic-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.16rem;
  position: relative;
  .back {
    font-size: 0;
    cursor: pointer;
    img {
      width: 0.26rem;
    }
  }
  .title {
    max-width: 45%;
    font-size: 0.12rem;
    font-weight: bold;
    color: #fff;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .statistics {
    height: 0.3rem;
    background: #ff9355;
    border-radius: 0.15rem;
    border: 1px solid #ffc797;
    display: flex;
    align-items: center;
    padding-left: 0.06rem;
    color: #630200;
    .correct,
    .error {
      line-height: 0.22rem;
      background: linear-gradient(319deg, #fedd99 0%, #ffeecb 100%);
      border-radius: 0.15rem;
      text-align: center;
      font-size: 0.12rem;
      font-weight: bold;
      margin-right: 0.05rem;
      padding: 0 0.14rem;
    }
    .num {
      line-height: 0.28rem;
      background: #ffe56f;
      box-shadow: inset 0 0.03rem 0.06rem 1px #ffffff;
      border-radius: 0.14rem;
      padding: 0 0.14rem;
      font-size: .12rem;
      margin-right: -1px;
      .current {
        font-size: .16rem;
        font-weight: bold;
      }
    }
  }
  .complete {
    width: 0.8rem;
    height: 0.26rem;
    background: url("~@/assets/img/confirm-btn1.png") center center / 100% 100%
      no-repeat;
    color: #630200;
    font-weight: bold;
    font-size: 0.12rem;
    text-align: center;
    line-height: 0.26rem;
    cursor: pointer;
  }
}
</style>